import axios from "axios";
import { keycloakAuthService } from "./keycloak-auth.service";

export function setBearerTokenForAllRequests(token: string) {
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  axios.defaults.baseURL =
    import.meta.env.MODE == "development"
      ? import.meta.env.VITE_APP_BASE_URL
      : location.origin;

  axios.interceptors.response.use(
    (res) => res,
    (error) => {
      if (error?.response?.status == 401) {
        keycloakAuthService.logout();
      } else {
        throw error;
      }
    },
  );
}

export default axios;
